import { useCallback, useState } from "react";

/*
 * Putting an outstanding balance on the card the booking has, and asking for
 * another one when it turns out there isn't a chargeable one. Shared by every
 * surface that offers to take a payment, so the "card declined, ask for
 * another" path behaves the same wherever the desk meets it.
 */
export default function useSettleBalance(charge, bookingId) {
  const [addCardOpen, setAddCardOpen] = useState(false);

  const settle = useCallback(async () => {
    if (!charge.hasCardOnFile && bookingId) {
      setAddCardOpen(true);
      return;
    }

    /* The card the booking thought it had is not chargeable. Ask for another
     * one rather than leaving the desk with nothing but an error. */
    if ((await charge.pay()) === "needs-card" && bookingId) {
      setAddCardOpen(true);
    }
  }, [charge, bookingId]);

  const openDifferentCard = useCallback(() => {
    charge.clearPayError();
    setAddCardOpen(true);
  }, [charge]);

  const onCardAdded = useCallback(() => {
    setAddCardOpen(false);
    charge.pay();
  }, [charge]);

  return {
    settle,
    addCardOpen,
    openDifferentCard,
    closeAddCard: () => setAddCardOpen(false),
    onCardAdded,
  };
}
